import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';
import { EMPTY_ID } from '@e-socna/empty-client';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const MaterialPage_OneMaterial_QueryDocument = graphql(`
  query MaterialPage_OneMaterial_Query($id: Id!) {
    findOneMaterial(id: $id) {
      code
      label
      ...MaterialPage_Tabs_Material_Fragment
      ...ServiceUsageCardCmp_Material_Fragment
    }
  }
`);

export type MaterialPage_OneMaterial = ResultOf<
  typeof MaterialPage_OneMaterial_QueryDocument
>['findOneMaterial'];

export const useFindOneMaterialQuery = (id = EMPTY_ID) =>
  useGraphQLQuery(
    MaterialPage_OneMaterial_QueryDocument,
    { id },
    { enabled: !!id },
  );
